import { ItemWithLabel, StatusTag } from '@innovyze/stylovyze';
import React from 'react';

import { useGlobalization } from '@Translations/useGlobalization';
import { IntegrationStatus } from '../../../../types/integration.types';

type Color =
	| 'positive'
	| 'standard'
	| 'neutral'
	| 'warning'
	| 'danger'
	| 'new'
	| 'negligible'
	| 'low'
	| 'medium'
	| 'high'
	| 'extreme';

const statusMap: Record<IntegrationStatus, { color: Color; text: string }> = {
	[IntegrationStatus.Disabled]: {
		color: 'neutral',
		text: 'Disabled',
	},
	[IntegrationStatus.Enabled]: {
		color: 'positive',
		text: 'Enabled',
	},
};

export const StatusItemWithLabel = ({
	status,
}: {
	status: IntegrationStatus;
}) => {
	const { t } = useGlobalization();
	const { color, text } = statusMap[status];

	return (
		<ItemWithLabel
			label={t('Status')}
			value={<StatusTag color={color} text={t(text)} />}
		/>
	);
};
